import reselect from 'reselect';
import _ from 'lodash';

import { RequestState, } from 'constants/constants';


// ======================
// HELPERS
// ====================== 
export const createList = (items, model, modelKey) => {
  return {
    list: _.map(items, modelKey),
    model,
    modelKey,
  }
}

export const mergeList = (listA, listB, unique = true) => {
  return {
    list: _.union(listA?.list, listB?.list),
    model: listA?.model ?? listB.model,
    modelKey: listA?.modelKey ?? listB?.modelKey,
  }
}

// Creates a selector that whenever the models or the specific list changes, fetch the models
export const createListSelector = (state, listType, listKey, selectors = []) => {
  return createSelector([
    s => s.models[s.lists[listKey]?.model],
    s => selectList(s, listType, listKey),
    ...selectors
  ],
    () => selectListModels(state, listType, listKey)
  )
}

// Reduces a new set of items into the list
export function listReducer(state, items, model, listType, path, modelKey = 'id') {
  let newLists = items
    |> _.castArray
    |> _.groupBy(#, path)
    |> _.mapValues(#, items => createList(items, model, modelKey))
  return {
    ..._.mergeWith(state[listType], newLists, mergeList)
  };
}

// Reduces a new set of items into the list of a specific key
export function listReducerByKey(state, items, model, listType, listKey, modelKey = 'id') {
  return {
    ...state[listType],
    [listKey]: createList(items, model, modelKey),
  };
}

export const selectList = (state, listType, listKey) => state.lists[listType]?.[listKey];
export const selectLists = (state, list) => state.lists[list];

// Selects the models that a list represents
export const selectListModels = (state, listType, key) => {
  let { list: ids, model: modelType, modelKey } = state.lists[listType]?.[key] ?? {};
  return _.pick(state.models?.[modelType], ids)
    |> _.values(#)
}



// ======================
// STORE
// ====================== 

export const ListState = {
  init: models => {
    ListState.spec = _.assign({}, ..._.map(models, e => e.listSpec));

    let reducers = _.chain(models)
      .map('listReducer')
      .compact()
      .value();

    ListState.reducer = (state = ListState.spec, action) => {
      if(action.url && (action.result !== RequestState.SUCCESS || action.json === undefined || !_.isEmpty(action.json.errors)))
        return state;

      let { json, type } = action;
      let body = _.get(json, 'body');

      return _.reduce(reducers, (s, f) => {
        return f(s, type, body, action);
      }, state);
    };
  },
  spec: {},
  actions: {},
  reducer: null,
}
export default ListState;